module.exports = __webpack_public_path__ + "img/dongtaiyaowen_back.af002ada.jpg";